import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", new_password: password }); setDone(true); }
    catch (err) {
      toast.error(err.response?.status === 400
        ? t({ en: "This reset link is invalid or has expired. Please request a new one.", fr: "Ce lien est invalide ou expiré. Veuillez en demander un nouveau." })
        : t({ en: "Password must be at least 8 characters.", fr: "Le mot de passe doit contenir au moins 8 caractères." }));
    } finally { setLoading(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16 lg:py-24" data-testid="reset-password-page">
      <div className="overline mb-4">{t({ en: "Password help", fr: "Aide mot de passe" })}</div>
      <h1 className="font-serif text-4xl mb-6 tracking-tight" style={{ color: "var(--ink)" }}>{t({ en: "Choose a new password.", fr: "Choisissez un nouveau mot de passe." })}</h1>
      {done ? (
        <div className="space-y-6" data-testid="reset-password-done">
          <p style={{ color: "var(--ink-2)" }}>{t({ en: "Your password has been updated. You can now sign in.", fr: "Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter." })}</p>
          <Link to="/login" className="btn-primary" data-testid="reset-go-login">{t({ en: "Sign in", fr: "Se connecter" })}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t({ en: "New password (8+ characters)", fr: "Nouveau mot de passe (8 caractères min.)" })} className="w-full p-3 rounded-lg border" style={{ borderColor: "var(--border-medium)", background: "var(--surface)" }} data-testid="reset-password-input" />
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="reset-password-submit">
            {loading ? t({ en: "Saving…", fr: "Enregistrement…" }) : t({ en: "Save new password", fr: "Enregistrer" })}
          </button>
        </form>
      )}
    </div>
  );
}
